var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.125H3C1.6875 3.125 0.625 4.1875 0.625 5.5V14.5C0.625 15.8125 1.6875 16.875 3 16.875H17C18.3125 16.875 19.375 15.8125 19.375 14.5V5.5C19.375 4.1875 18.3125 3.125 17 3.125ZM18.125 14.5C18.125 15.1188 17.6187 15.625 17 15.625H3C2.38125 15.625 1.875 15.1188 1.875 14.5V5.5C1.875 4.88125 2.38125 4.375 3 4.375H17C17.6187 4.375 18.125 4.88125 18.125 5.5V14.5Z",
    fill: "#778797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 13.125H3.75C3.40487 13.125 3.125 13.4049 3.125 13.75C3.125 14.0951 3.40487 14.375 3.75 14.375H6.25C6.59512 14.375 6.875 14.0951 6.875 13.75C6.875 13.4049 6.59512 13.125 6.25 13.125Z",
    fill: "#778797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 6.25H3.75C3.40487 6.25 3.125 6.52987 3.125 6.875C3.125 7.22013 3.40487 7.5 3.75 7.5H16.25C16.5951 7.5 16.875 7.22013 16.875 6.875C16.875 6.52987 16.5951 6.25 16.25 6.25Z",
    fill: "#778797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionCard);
export default __webpack_public_path__ + "static/media/transaction-card.befb4f2761300b1689d66dfd142435d9.svg";
export { ForwardRef as ReactComponent };